import { BaseApi } from './base.api.js';

export class BcmRpoApi extends BaseApi {
    constructor(client) {
        super(client, '/bcm-rpo');
    }
}
